<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview v-bind:title="'Nilai Akhir Per Semester'">
                    <template v-slot:body>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="">Piih Tahun Akademik</label>
                                <SelectAngkatan :selectedValue="request.selectedTahunAkademik" :changegeneration="changeGeneration">
                                </SelectAngkatan>
                            </div>
                            <div class="col-lg-4 ml-auto">
                                <label for="">Piih Prodi</label>
                                <SelectProdi :selectedValue="request.selectedProdi" :changeprodi="changeProgram">
                                </SelectProdi>
                            </div>
                        </div>
                        <v-card-title>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="NilaiAkhirSemester.search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-card-title>
                        <v-data-table :headers="NilaiAkhirSemester.headers" :items="NilaiAkhirSemester.data"
                            :search="NilaiAkhirSemester.search">
                            <template v-slot:item.no="{ index }">
                                {{ index + 1 }}.
                            </template>
                            <template v-slot:item.action="{ index }">
                                <ButtonComponent colors="#3751E4" name="print" @click.native="redirectToDetail(index)" />
                            </template>
                        </v-data-table>
                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
// import SelectComponent from "@/view/content/components/select/SelectComponent.vue";
import SelectProdi from "@/view/content/components/select/SelectProdi.vue"
import SelectAngkatan from "@/view/content/components/select/SelectAngkatan.vue"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";

export default {
    data() {
        return {
            NilaiAkhirSemester: {
                search: "",
                headers: [
                    { text: "No", value: "no", align: "center", sortable: false },
                    { text: "NRP", value: "nim", align: "center" },
                    { text: "Nama", value: "name", align: "center" },
                    { text: "NAA", value: "NA Akademik", align: "center" },
                    { text: "NAJ", value: "NA Jasmani", align: "center" },
                    { text: "NOAK", value: "NA Kepribadian", align: "center" },
                    { text: "IP", value: "IP", align: "center" },
                    { text: "Predikat", value: "predicate", align: "center" },
                    { text: "Aksi", value: "action", align: "center", sortable: false },
                ],
                data: []
            },
            request: {
                selectedProdi: null,
                selectedTahunAkademik: null
            }
        }
    },
    components: {
        KTCodePreview,
        ButtonComponent,
        // SelectComponent,
        SelectProdi,
        SelectAngkatan,
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Penilaian Akademik" },
            { title: "Nilai Akhir Semester" }
        ]);
    },
    methods: {
        async getData(){
            if(this.request.selectedTahunAkademik != null && this.request.selectedProdi != null){
                const result_edit = await axios.get(`master/final-score/gpa/${this.request.selectedTahunAkademik}/${this.request.selectedProdi}`);
                this.NilaiAkhirSemester.data = result_edit.data.data
            }
        },
        changeGeneration: function (selected) {
            this.request.selectedTahunAkademik = selected;
            this.getData()
        },
        changeProgram: function (selected) {
            this.request.selectedProdi = selected;
            this.getData()
        },
    },
}

</script>